import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import clsx from "clsx";
import { getDiscountPrice, getDiscountPrice2 } from "../../helpers/product";
import ProductImageGallery from "../../components/product/ProductImageGallery";
import ProductDescriptionInfo from "../../components/product/ProductDescriptionInfo";
import ProductImageGallerySideThumb from "../../components/product/ProductImageGallerySideThumb";
import ProductImageFixed from "../../components/product/ProductImageFixed";
import { useState } from "react";
import { useEffect } from "react";

const ProductImageDescription = ({
    spaceTopClass,
    spaceBottomClass,
    galleryType,
    product,
}) => {
    const currency = useSelector((state) => state.currency);
    const { cartItems } = useSelector((state) => state.cart);
    const { wishlistItems } = useSelector((state) => state.wishlist);
    const { compareItems } = useSelector((state) => state.compare);
    const wishlistItem = wishlistItems.find((item) => item.id === product.id);
    const compareItem = compareItems.find((item) => item.id === product.id);

    const discountedPrice = getDiscountPrice2(
        product.sale_price,
        product.discount
    );
    const finalProductPrice = +(
        product.retail_price * currency.currencyRate
    ).toFixed(2);
    const finalDiscountedPrice = +(
        discountedPrice * currency.currencyRate
    ).toFixed(2);

    const [selectedVariant, setSelectedVariant] = useState(
        product.variants?.[0] || product
    );

    useEffect(() => {
        if (product) {
            setSelectedVariant(product.variants?.[0] || product);
        }
    }, [product]);

    return (
        <div className={clsx("shop-area", spaceTopClass, spaceBottomClass)}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-6">
                        {/* product image gallery */}
                        {galleryType === "leftThumb" ? (
                            <ProductImageGallerySideThumb
                                product={selectedVariant}
                                thumbPosition="left"
                            />
                        ) : galleryType === "rightThumb" ? (
                            <ProductImageGallerySideThumb
                                product={selectedVariant}
                            />
                        ) : galleryType === "fixedImage" ? (
                            <ProductImageFixed product={selectedVariant} />
                        ) : (
                            <ProductImageGallery product={selectedVariant} />
                        )}
                    </div>
                    <div className="col-lg-6 col-md-6">
                        {/* product description info */}
                        <ProductDescriptionInfo
                            product={product}
                            selectedVariant={selectedVariant}
                            setSelectedVariant={setSelectedVariant}
                            discountedPrice={discountedPrice}
                            currency={currency}
                            finalDiscountedPrice={finalDiscountedPrice}
                            finalProductPrice={finalProductPrice}
                            cartItems={cartItems}
                            wishlistItem={wishlistItem}
                            compareItem={compareItem}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

ProductImageDescription.propTypes = {
    galleryType: PropTypes.string,
    product: PropTypes.shape({}),
    spaceBottomClass: PropTypes.string,
    spaceTopClass: PropTypes.string,
};

export default ProductImageDescription;
